export const PlanningItemType = {
    DROP: 10,
    BUFFERSLOT: 20,
    UNPRODUCTIVE_TIME: 30
};